import { atom } from "recoil";

export const userIsPlatformOperatorAtom = atom<boolean | undefined>({
  key: "userIsPlatformOperatorAtom",
  default: undefined,
});
